import React, { FC } from 'react'
import styled from 'styled-components'

import { SubTitle, Text } from '../CssStyled'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { css } from 'styled-components'
import { lng } from '@ads/front-core/locales'

interface IOurPossibilitiesCard {
  title: string
  img: string
  isReversed?: boolean
  onClick?: () => void
}

const Card: FC<IOurPossibilitiesCard> = ({
  title,
  img,
  isReversed,
  onClick,
  children,
}) => (
  <CardContainer isReversed={isReversed}>
    <CardBody>
      <CardHeader>
        <SubTitle bold>{title}</SubTitle>
      </CardHeader>

      <ImgWrapper isMobile>
        <img src={img} />
      </ImgWrapper>

      <Text>{children}</Text>

      <TextButton isReversed={isReversed} onClick={onClick}>
        {lng('landing:checkExamples')}
      </TextButton>
    </CardBody>
    <ImgWrapper>
      <img src={img} />
    </ImgWrapper>
  </CardContainer>
)

const CardContainer = styled.div<{ isReversed: boolean }>`
  display: flex;
  flex-direction: ${p => (p.isReversed ? 'row-reverse' : 'row')};
  gap: 50px;
  height: 364px;

  @media (max-width: ${breakpoints.MOBILE}) {
    flex-direction: column;
    gap: 34px;
    height: auto;
  }
`

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 654px;

  @media (max-width: ${breakpoints.MOBILE}) {
    width: 100%;
  }
`

const CardHeader = styled.div`
  margin-bottom: 24px;
  padding: 36px 24px;
  background-color: #f2f3f5;

  @media (max-width: ${breakpoints.MOBILE}) {
    margin: 0 -16px;
  }
`

const ImgWrapper = styled.div<{ isMobile?: boolean }>`
  margin-top: 10px;

  img {
    width: 100%;
    max-width: 600px;
  }

  ${p =>
    p.isMobile &&
    css`
      display: none;
    `}

  @media (max-width: ${breakpoints.MOBILE}) {
    display: none;

    ${p =>
      p.isMobile &&
      css`
        display: flex;
        justify-content: center;
        margin-bottom: 34px;
      `}
  }
`

const TextButton = styled.button<{ isReversed: boolean }>`
  align-self: ${p => (p.isReversed ? 'flex-end' : 'flex-start')};
  margin-top: 24px;
  border: none;
  background: transparent;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;
  color: #ec1c24;
  cursor: pointer;

  @media (max-width: ${breakpoints.MOBILE}) {
    align-self: flex-end;
  }
`

export default Card
